export default __webpack_public_path__ + "static/media/MAY2022.a5b14a70.png";